import React from "react";
import AboutUsMap from "../../components/aboutUsMap/AboutUsMap";
import AboutUsSection from "../../components/aboutUsSection/AboutUsSection";
import AboutUsPermits from "../../components/aboutUsPermits/AboutUsPermits";
import "./AboutUs.css";
import AboutUsGallery from "../../components/aboutUsGallery/AboutUsGallery";

const AboutUs = () => {
  return (
    <div className="marginTop">
      <AboutUsGallery />
      <AboutUsPermits />
      <AboutUsMap />
      <AboutUsSection />
    </div>
  );
};

export default AboutUs;
